import React, { useState } from 'react';
// import Services from '../../api/service'
// import ServiceSingle from '../ServiceSingle';
import CustomerReport from '../CustomerReport/CustomerReport';

const  CustomerReportSection = (props) => {

    const [open, setOpen] = React.useState(false);

    function handleClose() {
        setOpen(false);
    }

    const [state, setState] = useState({
    })

    const handleClickOpen = (item) => {
        setOpen(true);
        setState(item)
    }


    return (

        <section className="service-section" id="Services">
            
                <div className="row">
                  <CustomerReport/>
                
                  
                </div>
           
           
        </section>
    );
}

export default CustomerReportSection;